import React, { useEffect, useRef, useState } from 'react';
import $ from 'jquery';
import * as R from "ramda";
import { DeleteUser } from './../../_common/deleteUser';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import countriesList from 'iso-3166-1-alpha-2';
import countryTelData from 'country-telephone-data';
import parsePhoneNumber from 'libphonenumber-js';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { LoadingState } from '../../../_common/loadingState';
import * as Loadings from '../../../constants/loadings/backoffice/clients';
import { deleteClient, resetPassword, updateClient, updateClientSecurity } from '../../../actions/backoffice/clients';



export const ClientsMain = ({ clientsState, pageNumber, setPageSearch, pageSearch, routerQuery }) => {
	const user = useSelector(state => state.user);


	var countries = require("i18n-iso-countries");
	countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
	const updateClientAccount = useRef();
	const buttonRef = useRef();


	const dispatch = useDispatch();

	const [usersToDisplay, setUsersToDisplay] = useState(clientsState.clients);
	const [selectedClient, setSelectedClient] = useState({ email: "", phoneNumber: "", countryCode: "" });
	const [selectedClientCopy, setSelectedClientCopy] = useState({});
	const statusOptions = { user: "Utilisateur", admin: "Administrateur", partner: "Partenaire", representative: "Mandataire", etablissement: "Etablissement" };
	const [saveNumber, setsaveNumber] = useState("");
	const searchRef = useRef();

	const [filters, setFilters] = useState({
		order: {
			column: "lastName",
			asc: false
		},
		role: undefined,
		search: "",
	});

	useEffect(() => {

		if (!R.isNil(searchRef.current) && pageSearch !== "") {
			searchRef.current.focus();
		}

	}, [pageSearch]);


	useEffect(() => {
		$('[data-toggle="tooltip"]').tooltip();


		let temp = clientsState.clients.filter(c => c.id !== user.user.id);

		// if (!R.isNil(clientsState.globalFilters.role)) {
		// 	temp = temp.filter(user => user.roles.some(r => r === clientsState.globalFilters.role));

		// }

		// if (clientsState.globalFilters.order.asc) {
		// 	temp = R.sort(R.ascend(R.prop(filters.order.column)), temp);
		// }

		// if (!R.isEmpty(filters.search)) {
		// 	//temp = temp.filter(user => user.firstName?.toLowerCase().includes(filters.search.toLowerCase()) || user.lastName?.toLowerCase().includes(filters.search.toLowerCase()));
		// }


		setUsersToDisplay(temp);

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [filters, clientsState]);

	useEffect(() => {

		const filterForm = document.querySelector("#filterForm");
		const handleClick = (e) => {
			if (e.target.type === "button") {
				e.target.parentElement.classList.remove("show");
			}
		};
		const filterFormEvent = filterForm.addEventListener("click", handleClick);

		return () => filterForm.removeEventListener("click", handleClick);
	}, []);

	function handleUpdateClientAccount(e) {
		e.preventDefault();



		updateClientAccount.current.classList.add("was-validated");

		if (updateClientAccount.current.checkValidity()) {

			const phoneNumber = selectedClient.phoneNumber.includes("+") ? "+" + selectedClient.countryCode + parsePhoneNumber(selectedClient.phoneNumber).nationalNumber.replace(/ /g, '') : "+" + selectedClient.countryCode + selectedClient.phoneNumber.replace(/ /g, '');


			if (selectedClientCopy.isEnabled !== selectedClient.isEnabled) {
				const clientUpdateInfo = {
					id: selectedClient.id,
					gender: selectedClient.gender,
					isEnabled: selectedClient.isEnabled,
					firstName: selectedClient.firstName,
					lastName: selectedClient.lastName,
					birthDate: selectedClient.birthDate,
					birthPlace: selectedClient.birthPlace,
					departmentNumber: selectedClient.departmentNumber,
					country: selectedClient.country,
					civilStatus: selectedClient.civilStatus,
					hasChildren: selectedClient.hasChildren,
					professionalSituation: selectedClient.professionalSituation.toString(),
					onBoardingStep: selectedClient.onBoardingStep,

				};

				dispatch(updateClient(selectedClient.id, clientUpdateInfo));
			}

			if (selectedClientCopy.phoneNumber !== selectedClient.phoneNumber) {
				dispatch(updateClientSecurity(selectedClient.id, { newPhoneNumber: phoneNumber }));
			}

			if (selectedClientCopy.email !== selectedClient.email) {
				dispatch(updateClientSecurity(selectedClient.id, { newEmail: selectedClient.email }));

			}

			buttonRef.current.setAttribute("data-dismiss", "modal");
			buttonRef.current.click();


		}
		buttonRef.current.removeAttribute("data-dismiss");
	}


	function handleDeleteUser(client) {
		dispatch(deleteClient(client));
	}



	return (
		<article className="view-calc pt-sm mb-auto pb-sm">
			<div className="container-fluid">
				<nav className="navbar navbar-expand navbar-light px-0 mb-2">
					<button className="btn-icon btn-alert bg-white navbar-toggler border-0 mx-auto rounded-max px-1" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
						<span className="btn-alert-primary eva eva-menu-outline rounded-inherit my-auto lh-1 fs-sm p-2"></span>
						<span className="text-gray h6 lh-1 my-auto ml-2 mr-3">Menu</span>
					</button>
					<div className="collapse navbar-collapse flex-column" id="navbarNav">
						<form className="form-inline container-hd mx-auto justify-content-center" id="filterForm" onSubmit={(e) => e.preventDefault()}>
							<div className={"my-1 input-group btn-dim rounded-max ml-xl-auto w-100 w-md-auto" + (pageSearch !== "" ? " active" : "")}>
								<input type="text" className="form-control bg-none rounded-inherit border-none no-focus shadow-none" placeholder="Recherche" aria-label="Recherche" ref={searchRef} value={pageSearch} onChange={(e) => /*setFilters({ ...filters, search: e.target.value })*/ setPageSearch(e.target.value)} />
								<div className="input-group-prepend rounded-inherit">
									<button type="button" className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4"><i className="eva eva-search-outline align-middle fs-root lh-0 o-70 o-100--hover"></i></button>
								</div>
							</div>
							{/* <div className={"my-1 input-group btn-dim rounded-max ml-md-2 btn-alert" + (!R.isEmpty(routerQuery.roles) ? " active" : "")} role="button">
								<p className="form-control bg-none border-none rounded-inherit my-auto small" id="dropdownMenuButtonType" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{R.isEmpty(routerQuery.roles) ? "Tous les roles" : statusOptions[routerQuery.roles]}</p>
								<div className="input-group-prepend rounded-inherit dropdown">
									<button type="button" className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4" id="dropdownMenuButtonType" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
										<i className="eva eva-options-outline align-middle fs-root lh-0 o-70 o-100--hover"></i>
									</button>
									<div className="dropdown-menu dropdown-menu-right border-none shadow" aria-labelledby="dropdownMenuButtonType">
										<Link className={"dropdown-item py-2 h6 mb-0" + (R.isEmpty(routerQuery.roles) ? " active" : "")} to={`/backoffice/clients?page=${1}${routerQuery.search !== "" ? "&search=" + routerQuery.search : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "" ? "" : routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`} type="button" >Tous les roles</Link>
										<Link className={"dropdown-item py-2 h6 mb-0" + (routerQuery.roles === "admin" ? " active" : "")} to={`/backoffice/clients?page=${1}${routerQuery.search !== "" ? "&search=" + routerQuery.search : ""}${"&roles=admin"}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "" ? "" : routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`} type="button"  >Administrateur</Link>
										<Link className={"dropdown-item py-2 h6 mb-0" + (routerQuery.roles === "user" ? " active" : "")} to={`/backoffice/clients?page=${1}${routerQuery.search !== "" ? "&search=" + routerQuery.search : ""}${"&roles=user"}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "" ? "" : routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`} type="button"  >Utilisateur</Link>
										<Link className={"dropdown-item py-2 h6 mb-0" + (routerQuery.roles === "representative" ? " active" : "")} to={`/backoffice/clients?page=${1}${routerQuery.search !== "" ? "&search=" + routerQuery.search : ""}${"&roles=representative"}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "" ? "" : routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`} type="button"  >Mandataire</Link>
										<Link className={"dropdown-item py-2 h6 mb-0" + (routerQuery.roles === "partner" ? " active" : "")} to={`/backoffice/clients?page=${1}${routerQuery.search !== "" ? "&search=" + routerQuery.search : ""}${"&roles=partner"}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "" ? "" : routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`} type="button" >Partenaire</Link>
										<Link className={"dropdown-item py-2 h6 mb-0" + (routerQuery.roles === "etablissement" ? " active" : "")} to={`/backoffice/clients?page=${1}${routerQuery.search !== "" ? "&search=" + routerQuery.search : ""}${"&roles=etablissement"}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "" ? "" : routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`} type="button" >Etablissement</Link>
									</div>
								</div>
							</div> */}
							<div className={"my-1 input-group btn-dim rounded-max ml-2 btn-alert active" + (routerQuery.sortBy === "lastName" ? " active" : "")} role="button">
								<p className="form-control bg-none border-none rounded-inherit my-auto small" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{routerQuery.sortBy === "lastName" ? "Ordre alphabétique" : "Les plus récents"}</p>
								<div className="input-group-prepend rounded-inherit dropdown">
									<button type="button" className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
										<i className="eva eva-funnel-outline align-middle fs-root lh-0 o-70 o-100--hover"></i>
									</button>
									<div className="dropdown-menu dropdown-menu-right border-none shadow" aria-labelledby="dropdownMenuButton">
										{/* <button className={"dropdown-item py-2 h6 mb-0 " + (!clientsState.globalFilters.order.asc ? "active" : "")} type="button" onClick={() => dispatch(setFilterGlobal({ order: { column: "lastName", asc: false } }))}>Les plus récents</button>
										<button className={"dropdown-item py-2 h6 mb-0 " + (clientsState.globalFilters.order.asc ? "active" : "")} type="button" onClick={() => dispatch(setFilterGlobal({ order: { column: "lastName", asc: true } }))}>Ordre alphabétique</button> */}
										<Link className={"dropdown-item py-2 h6 mb-0 " + (routerQuery.sortBy === "creationDate" ? "active" : "")} to={`/backoffice/clients?page=${1}${routerQuery.search !== "" ? "&search=" + routerQuery.search : ""}${routerQuery.roles !== "" ? "&roles=" + routerQuery.roles : ""}${"&sortBy=creationDate"}${"&sortDesc=true"}`} type="button" >Les plus récents</Link>
										<Link className={"dropdown-item py-2 h6 mb-0 " + (routerQuery.sortBy === "lastName" ? "active" : "")} to={`/backoffice/clients?page=${1}${routerQuery.search !== "" ? "&search=" + routerQuery.search : ""}${routerQuery.roles !== "" ? "&roles=" + routerQuery.roles : ""}${"&sortBy=lastName"}${"&sortDesc=false"}`} type="button">Ordre alphabétique</Link>
									</div>
								</div>
							</div>
						</form>
					</div>
				</nav>
			</div>
			<div className="auto-view h-100 mb-auto">
				{
					clientsState.isLoading.includes(Loadings.FETCHING_CLIENTS) ?
						<LoadingState />
						:
						<div className="container-fluid">
							{!R.isEmpty(usersToDisplay) ?
								<section className="block grid grid-sm-min grid-lg-narrow grid-hd-auto mb-4">
									{
										usersToDisplay.map(client => {
											let phone = null;
											if(!R.isNil(client.phoneNumber)){
												phone = parsePhoneNumber(client.phoneNumber);
											}
											return (
												<div className="card text-center h-100 rounded shadow--hover" key={client.id}>
													<div className="card-body my-auto px-3 flex-column">
														<h4 className="h3 text-capitalize ls-n1 font-weight-black mt-auto mb-2">
															{client.firstName} {client.lastName}
															{/* {client.roles.includes("partner") && <i
														className="eva eva-award-outline fs-sm lh-root text-primary ml-1 align-middle" data-toggle="tooltip"
														data-placement="bottom"
														data-template='<div class="tooltip tooltip-white-primary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner shadow px-3 py-2 font-weight-regular lh-root"></div></div>'
														title="Partner client"></i>} */}
														</h4>
														<div className="row justify-content-center gx-1">
															{
																client.roles.map((role, i) => (
																	<p className="fs-3 text-uppercase lh-copy o-40 font-weight-bolder mb-0" key={role + i}>
																		{statusOptions[role.toLowerCase()]}</p>
																))
															}
														</div>
													</div>
													<div className="flex-row fs-2 mx-auto mb-auto justify-content-center w-100 font-weight-bolder py-1 bg-light">
														<span className="o-60">Statut: </span>
														{
															client.isEnabled ? <span className="text-uppercase mx-1 text-success">Actif</span> : <span className="text-uppercase mx-1">Desactivé(e)</span>
														}
													</div>
													<hr className="my-0 o-0" />
													<div className="card-footer alin-items-center border-light px-2 py-1 rounded-0 bg-none">
														<button className="btn btn-icon btn-stage-info rounded-max p-2 mx-1 shadow-none" data-toggle="modal" data-target="#userAccount" onClick={() => { setSelectedClient({ ...client, countryCode: R.isNil(phone) ? null : parseInt(phone.countryCallingCode), phoneCountry: R.isNil(phone) ? null : phone.country }); setSelectedClientCopy(client); }}><i className="eva fs-sm eva-person-outline" data-toggle="tooltip" data-template='<div class="tooltip tooltip-white-info" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>' data-placement="top" title="Données utilisateur"></i></button>
														<button className="btn btn-icon btn-stage-warning rounded-max p-2 mx-1 shadow-none" onClick={() => dispatch(resetPassword(client.email, client.phoneNumber))}><i className="eva fs-sm eva-email-outline" data-toggle="tooltip" data-placement="top" data-template='<div class="tooltip tooltip-white-warning" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>' title="Envoyer un e-mail de récupération"></i></button>
														<button className="btn btn-icon btn-stage-danger rounded-max p-2 mx-1 shadow-none" data-toggle="modal" data-target="#deleteUser" onClick={() => setSelectedClient(client)}><i className="eva fs-root eva-trash-2-outline" data-toggle="tooltip" data-placement="bottom" data-template='<div class="tooltip tooltip-white-danger" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>' title="Supprimer le utilisateur"></i></button>
													</div>
												</div>
											);
										})
									}

								</section>
								:
								<div className="flex-column p-3 mt-5  h-100 ">
									<div className="container container-base text-center m-auto">
										<h5 className="sr-only visually-hidden">Agent - Empty</h5>
										<div className="display-4 font-weight-black ls-n1 lh-1 mb-3">On dirait <br />qu'il est vide.</div>
										<p className="text-lg mb-4 o-66">Malheureusement, nous ne parvenons pas à trouver le contenu que vous recherchez.</p>
									</div>
								</div>
							}
						</div>}
			</div>
			<div className="container">
				<nav className="flex-row my-3 justify-content-center" aria-label="Page navigation">
					{clientsState.currentPage > 1 ? <Link to={`/backoffice/clients?page=${1}${pageSearch === "" ? "" : "&search=" + pageSearch}${routerQuery.roles !== "" ? "&roles=" + routerQuery.roles : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc !== "" ? "&sortDesc=" + routerQuery.sortDesc : ""}`} className={"btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"}><i className="eva lh-1 eva-arrowhead-left-outline fs-2"></i></Link> : <button disabled className={"btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"}><i className="eva lh-1 eva-arrowhead-left-outline fs-2"></i></button>}
					{clientsState.currentPage > 1 ? <Link to={`/backoffice/clients?page=${clientsState.currentPage - 1}${pageSearch === "" ? "" : "&search=" + pageSearch}${routerQuery.roles !== "" ? "&roles=" + routerQuery.roles : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc !== "" ? "&sortDesc=" + routerQuery.sortDesc : ""}`} className={"btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"}><i className="eva lh-1 eva-arrow-ios-back-outline fs-2"></i></Link> : <button disabled className={"btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"}><i className="eva lh-1 eva-arrow-ios-back-outline fs-2"></i></button>}

					<span className="btn rounded-sm bg-dim px-2 py-1 mx-1 d-flex justify-content-center align-items-center fs-aux">{clientsState.currentPage} de {clientsState.totalPages}</span>

					{clientsState.currentPage < clientsState.totalPages ? <Link to={`/backoffice/clients?page=${clientsState.currentPage + 1}${pageSearch === "" ? "" : "&search=" + pageSearch}${routerQuery.roles !== "" ? "&roles=" + routerQuery.roles : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc !== "" ? "&sortDesc=" + routerQuery.sortDesc : ""}`} className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrow-ios-forward-outline fs-2"></i></Link> : <button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrow-ios-forward-outline fs-2"></i></button>}
					{clientsState.currentPage < clientsState.totalPages ? <Link to={`/backoffice/clients?page=${clientsState.totalPages}${pageSearch === "" ? "" : "&search=" + pageSearch}${routerQuery.roles !== "" ? "&roles=" + routerQuery.roles : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc !== "" ? "&sortDesc=" + routerQuery.sortDesc : ""}`} className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrowhead-right-outline fs-2"></i></Link> : <button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrowhead-right-outline fs-2"></i></button>}
				</nav>
			</div>
			<div className="modal fade px-0" id="userAccount" aria-labelledby="userAccountLabel" aria-hidden="true" >
				<div className="modal-dialog px-2">
					<div className="modal-content">
						<header className="modal-header">
							<div className="alert bg-common rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
								<h1 className="sr-only visually-hidden">User Account Donnes</h1>
								<div className="flex-row align-items-center justify-content-between">
									<div className="h4 text-primary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="userAccountLabel">Données du compte utilisateur</div>
									<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
										<i className="eva eva-close fs-4"></i>
									</button>
								</div>
							</div>
						</header>
						<div className="modal-body scroll-default py-0">
							<p className="h5 lh-copy mb-sm">Consultez et modifiez ci-dessous les détails du compte <strong>{selectedClient.firstName} {selectedClient.lastName}</strong> en conséquence.</p>
							<section className="card card-body bg-light rounded">
								<form className="form" noValidate id="useraccountForm" onSubmit={handleUpdateClientAccount} ref={updateClientAccount}>
									<div className="form-group container-copy">
										<label className="h6 font-weight-bolder lh-root" htmlFor="telephone">Numéro de téléphone de l'utilisateur</label>
										<div className="input-group mb-0">
											{/* <select className="custom-select rounded container-paper container-sm-tiny mr-2" id="naturalite" tabIndex={-98} value={selectedClient.country} onChange={(e) => setSelectedClient({ ...selectedClient, country: e.target.value })}> */}
											{/* <option key={"index"} value={'+'}>{'countries.getName(country, "fr", { select: "official" })'} (+{'dialCode'})</option> */}
											{/* <option value={'+'}>{countries.getName(country, "fr", { select: "official" })}</option> */}
											{/* {
													Object.keys(countriesList.getData()).map((country, index) => {
														return (
															<option key={index} value={country}>{countries.getName(country, "fr", { select: "official" })}</option>
														);
													})
												} */}
											{/* </select> */}
											<select className="custom-select rounded container-tiny mr-2" id={"phonecode"} tabIndex={-98} value={selectedClient.countryCode} onChange={(event) => {
												let pc = countryTelData.allCountryCodes[event.target.value][0].toUpperCase();
												setSelectedClient({ ...selectedClient, countryCode: event.target.value, phoneCountry: pc });
											}}>
												{
													Object.keys(countriesList.getData()).map((country, index) => {
														let dialCode = countryTelData.allCountries[countryTelData.iso2Lookup[country.toLowerCase()]].dialCode;

														return (
															<option key={index} value={dialCode}>{countries.getName(country, "fr", { select: "official" })} (+{dialCode})</option>
														);
													})
												}
											</select>
											<input required type="tel" className="form-control rounded" id={"phone"} placeholder="00 00 00 00 00" value={R.isNil(selectedClient.phoneNumber) ? null : parsePhoneNumber(selectedClient.phoneNumber, selectedClient.phoneCountry) !== undefined ? parsePhoneNumber(selectedClient.phoneNumber, selectedClient.phoneCountry).formatNational() : selectedClient.phoneNumber} aria-describedby="telephoneHelpBlock"
												onChange={(e) => {
													const phoneInput = document.getElementById("phone");
													const parsedPhoneNumber = parsePhoneNumber("+" + selectedClient.countryCode + e.target.value);
													if (R.isNil(parsedPhoneNumber) || !isValidPhoneNumber(parsedPhoneNumber.number)) {
														phoneInput.setCustomValidity("Numéro de télephone invalide.");
													} else {
														phoneInput.setCustomValidity("");

													}

													setSelectedClient({ ...selectedClient, phoneNumber: e.target.value });
												}} />
											{/* <input required type="tel" className="form-control rounded" id="telephone" placeholder="00 00 00 00 00" value={selectedClient.phoneNumber} onChange={(e) => setSelectedClient({ ...selectedClient, phoneNumber: e.target.value })} /> */}
											<div className="w-100 mb-1 d-md-none"></div>
											{/* <span className="input-group-text p-0 ml-md-1 border-none"><button className="btn btn-info rounded-inherit px-sm" >Envoyer code</button></span> */}
											<div className="invalid-feedback alert bg-alert-danger mt-2 mb-4">
												<i className="eva eva-alert-triangle-outline text-danger mr-1 fs-sm lh-root align-middle"></i>
												<span className="align-middle text-dark o-70">Valider votre numéro de téléphone</span>
											</div>
										</div>
										<p className="form-text small text-gray mt-2" id="telephoneHelpBlock"><i className="eva eva-info-outline text-info mr-1 fs-sm lh-root align-middle"></i><span className="align-middle">Nous utiliserons ce numéro pour assurer la sécurité de votre compte.</span></p>
									</div>
									<div className="form-group">
										<label className="h6 font-weight-bolder" htmlFor="email">Utilisateur e-mail</label>
										<input type="email" className="form-control" id="email" placeholder="votreemail@mail.fr" value={selectedClient.email} onChange={(e) => setSelectedClient({ ...selectedClient, email: e.target.value })} required pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" />
										<div className={"invalid-feedback"}>
											Champs invalide
										</div>
									</div>
									<div className="form-group mb-0">
										<label className="h6 font-weight-bolder" htmlFor="statut">Statut d'utilisateur</label>
										<select className="custom-select" id="statut" tabIndex={-98} value={selectedClient.isEnabled ? "actif" : "desactivé(e)"} onChange={(e) => setSelectedClient({ ...selectedClient, isEnabled: selectedClient.isEnabled ? false : true })}>
											<option value="actif" >Actif</option>
											<option value="desactivé(e)" >Desactivé(e)</option>
										</select>
									</div>
								</form>
							</section>
						</div>
						<div className="modal-footer">
							<button type="button" className="btn btn-light" data-dismiss="modal">Fermer</button>
							<button type="submit" className="btn btn-info border-none" form="useraccountForm" ref={buttonRef}  >Enregistrer</button>
						</div>
					</div>
				</div>
			</div>
			<DeleteUser selectedUser={selectedClient} deleteUser={handleDeleteUser} />
		</article>
	);
};